<template>
	<div class="vertical-line m-rl-auto sa sa--up"></div>
</template>

<script>
export default {
  name: 'VerticalLine',
}
</script>